import React, { Fragment, useCallback } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import PageTitleAlt from '../../../Layout/AppMain/PageTitle';

import {
    Button,
    Form,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    Container,
} from 'reactstrap';

import { useForm } from 'react-hook-form';
import { useAuth } from '../../../Context/Auth/AuthContext';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';

const schema = Yup.object().shape({
    old_password: Yup.string()
        .required('Password is required!')
        .min(6, 'Password must be at least 6 characters'),
    new_password: Yup.string()
        .required('Password is required!')
        .min(6, 'Password must be at least 6 characters'),
    new_password_confirmation: Yup.string()
        .required('Confirm password is required!')
        .oneOf([Yup.ref('new_password'), null], 'Passwords must match'),
});

export default function ChangePassword() {
    const { toggleLoading, authenticated } = useAuth();
    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: schema,
    });
    const history = useHistory();

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    const onSubmit = useCallback(
        async ({ old_password, new_password }) => {
            toggleLoading(true);
            api.post('/ro.team.change-password', {
                password: old_password,
                newPassword: new_password,
                email: userInfo().email,
            })
                .then((response) => {
                    toast.success('Your password has been changed!');
                    reset(response);
                    history.push('/groups');
                })
                .catch((err) => {
                    toast.error('An error ocurred, try again');
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [reset, toggleLoading, userInfo, history]
    );

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <PageTitleAlt
                    heading="Change password"
                    icon="pe-7s-user icon-gradient bg-ripe-malin"
                />

                <Container fluid>
                    <Card className="main-card mb-3">
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup row>
                                    <Label for="old_password" sm={2}>
                                        Old Password
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="password"
                                            name="old_password"
                                            id="old_password"
                                            placeholder="Old password"
                                            ref={register}
                                            className="form-control"
                                        />
                                        {errors.old_password && (
                                            <p className="error-validation-left">
                                                {errors.old_password.message}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="new_password" sm={2}>
                                        New Password
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="password"
                                            name="new_password"
                                            id="new_password"
                                            placeholder="New password"
                                            ref={register}
                                            className="form-control"
                                        />
                                        {errors.new_password && (
                                            <p className="error-validation-left">
                                                {errors.new_password.message}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label
                                        for="new_password_confirmation"
                                        sm={2}
                                    >
                                        New Password Confirmation
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="password"
                                            name="new_password_confirmation"
                                            id="new_password_confirmation"
                                            placeholder="New password confirmation"
                                            ref={register}
                                            className="form-control"
                                        />
                                        {errors.new_password_confirmation && (
                                            <p className="error-validation-left">
                                                {
                                                    errors
                                                        .new_password_confirmation
                                                        .message
                                                }
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup check row>
                                    <Col sm={{ size: 15, offset: 2 }}>
                                        <Button
                                            type="submit"
                                            value="Submit"
                                            color="success"
                                        >
                                            OK
                                        </Button>
                                        <Button
                                            color="secondary"
                                            className="ml-2"
                                            onClick={(evt) => {
                                                evt.preventDefault();
                                                history.push('/groups');
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </CSSTransitionGroup>
        </Fragment>
    );
}
